import { DefaultState, DropdownItem } from 'store/types';
import { ReservationProviderStatuses, OptionRequiredOptionalNotSupportedStatuses } from 'store/reducers/reservation-provider/types';

export const GET_RESERVATION_PROVIDERS_REQUEST = 'GET_RESERVATION_PROVIDERS_REQUEST';
export const GET_RESERVATION_PROVIDERS_SUCCESS = 'GET_RESERVATION_PROVIDERS_SUCCESS';
export const GET_RESERVATION_PROVIDERS_FAILURE = 'GET_RESERVATION_PROVIDERS_FAILURE';


export interface GetReservationProvidersParams {
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface ReservationProviderBaseData {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  website: string;
  status: ReservationProviderStatuses;
  requestNumberRequired: OptionRequiredOptionalNotSupportedStatuses;
  lodgingPolicyId: string;
  sendNotification: boolean;
  notificationEmail: string;
  labelColor: string;
  isDefault?: boolean;
}

export interface GetReservationProviderRow extends ReservationProviderBaseData { }

export interface GetReservationProvidersData {
  rows: GetReservationProviderRow[];
  totalCount: number;
  statusesSelectList?: DropdownItem[];
  requestNumberRequiredSelectList?: DropdownItem[];
  lodgingPolicySelectList?: DropdownItem[];
}

export type GetReservationProvidersState = DefaultState & {
  contents?: GetReservationProvidersData;
};

interface GetReservationProvidersRequest {
  type: typeof GET_RESERVATION_PROVIDERS_REQUEST;
}

interface GetReservationProvidersSuccess {
  type: typeof GET_RESERVATION_PROVIDERS_SUCCESS;
  contents: GetReservationProvidersData;
}

interface GetReservationProvidersFailure {
  type: typeof GET_RESERVATION_PROVIDERS_FAILURE;
}

export type GetReservationProvidersActionTypes = GetReservationProvidersRequest | GetReservationProvidersSuccess | GetReservationProvidersFailure;